// extracted by mini-css-extract-plugin
module.exports = {"personal-data":"style_personal-data__o9Ewc","personal-data__text":"style_personal-data__text__tYEz4","big-main-title":"style_big-main-title__6ic2X"};